(() => {
  if (customElements.get('arclo-worn-outside')) return;
  class WornOutside extends HTMLElement {
    connectedCallback() {
      if (this.onPhotoClick) return;
      this.cards = [...this.querySelectorAll('.awo__photo')];
      this.front = this.querySelector('.awo__photo.is-active');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => {
        if (this.motion.matches) this.settle();
      };
      this.motion.addEventListener('change', this.onMotionChange);
      this.onVisibilityChange = () => {
        if (document.hidden) this.settle();
      };
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.onPhotoClick = (event) => {
        const control = event.target.closest('button[data-photo-index]');
        if (control && this.contains(control)) this.select(control.dataset.photoIndex);
      };
      this.addEventListener('click', this.onPhotoClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onPhotoClick);
      this.settle();
      this.motion?.removeEventListener('change', this.onMotionChange);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.onPhotoClick = null;
    }
    cancelTransition() {
      clearTimeout(this.promotionTimer);
      clearTimeout(this.settleTimer);
    }
    settle() {
      this.cancelTransition();
      this.cards?.forEach((card) => card.style.removeProperty('z-index'));
      this.front = this.querySelector('.awo__photo.is-active');
    }
    select(index) {
      const next = this.cards.find((card) => card.dataset.photoIndex === String(index));
      if (!next || next.classList.contains('is-active')) return;
      this.cancelTransition();
      const previous = this.front;
      // Keep the currently visible front above the incoming photo during its initial lift.
      // Do not animate opacity or reorder nodes: every photo stays opaque in its fixed slot.
      this.cards.forEach((card) => card.style.removeProperty('z-index'));
      if (previous && previous !== next && !this.motion.matches && !document.hidden) {
        previous.style.zIndex = '20';
        next.style.zIndex = '19';
      }
      this.querySelectorAll('button[data-photo-index]').forEach((button) => {
        const active = button.dataset.photoIndex === String(index);
        button.setAttribute('aria-pressed', String(active));
        if (button.classList.contains('awo__photo')) button.classList.toggle('is-active', active);
      });
      this.querySelector('[data-worn-status]').textContent = `${String(index).padStart(2, '0')} / ${next.dataset.scene}`;
      if (this.motion.matches || document.hidden || previous === next) {
        this.settle();
        return;
      }
      // Commit both layer changes together after the first 80ms of the 450ms lift.
      // Rapid clicks cancel both callbacks, so an earlier choice cannot regain the front.
      this.promotionTimer = setTimeout(() => {
        next.style.zIndex = '21';
        previous?.style.removeProperty('z-index');
        this.front = next;
      }, 80);
      this.settleTimer = setTimeout(() => this.settle(), 450);
    }
  }
  customElements.define('arclo-worn-outside', WornOutside);
})();
